/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { LanguageHelp } from '../../../helpers/LanguageHelper'
import { KTSVG } from '../../../helpers'

type Props = {
  className?: string
  functionSubmit?: any
  selectedChannelType?: string
}

const changeDropDownText = (e: React.MouseEvent<Element, MouseEvent>) => {
  const target = e.target as HTMLInputElement;
  target.parentElement!.parentElement!.parentElement!.children[0].children[0].textContent = target.textContent
}

const DropdownFilterChannels: FC<Props> = ({ 
  className = '', 
  functionSubmit,
  selectedChannelType = 'All Platforms',
}) => {
  return (
    <div className= {className}>
      <a href='#' className='btn btn-light btn-active-light-primary btn-sm' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end'>
        <div style={{ display: 'unset' }}>{selectedChannelType}</div>
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      {/* begin::Menu */}
      <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-250px py-4 scroll-y mh-250px px-2' data-kt-menu='true'>
        {/* begin::Menu item */}
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit(LanguageHelp('All Platforms'), 'channeltype'); changeDropDownText(e); }} >
            {LanguageHelp('All Platforms')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('Api', 'channeltype'); changeDropDownText(e); }} >
            {LanguageHelp('Api')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('Twitter', 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('Twitter')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('Şikayet Var', 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('Şikayet Var')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('Ekşi Sözlük', 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('Ekşi Sözlük')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('IFrame', 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('IFrame')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit(LanguageHelp('Instagram Mentions'), 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('Instagram Mentions')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit(LanguageHelp('Instagram Comments'), 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('Instagram Comments')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('Youtube', 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('Youtube')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit('Reddit', 'channeltype'); changeDropDownText(e); }}>
            Reddit
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit(LanguageHelp('TikTok Mentions'), 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('TikTok Mentions')}
          </a>
        </div>
        <div className='menu-item px-3'>
          <a className='menu-link px-3' onClick={(e) => { functionSubmit(LanguageHelp('TikTok Comments'), 'channeltype'); changeDropDownText(e); }}>
            {LanguageHelp('TikTok Comments')}
          </a>
        </div>
        {/* end::Menu item */}
      </div>
      {/* end::Menu */}
    </div>
  )
}

export { DropdownFilterChannels }
